import type { AsyncBelongsTo } from '@ember-data/model';
import { attr, belongsTo, hasMany } from '@ember-data/model';
import AbstractGroupInvite from 'garaje/models/abstract/abstract-group-invite';
import type GroupInvite from 'garaje/models/group-invite';
import type Invite from 'garaje/models/invite';

export default class RecurringGroupInvite extends AbstractGroupInvite {
  @attr('string') declare recurringRule: string;
  @attr('date') declare startTime: Date | null;

  @belongsTo('group-invite', { async: true, inverse: null }) declare nextGroupInvite: AsyncBelongsTo<GroupInvite>;
  @belongsTo('recurring-group-invite', { async: true, inverse: null })
  declare previousRecurringGroupInvite: AsyncBelongsTo<RecurringGroupInvite>;

  /**
   * Set when creating a new recurring group invite from an existing recurring
   * group invite to exclude invites as part of the "delete" flow
   */
  @hasMany('invite', { async: false, inverse: null }) excludedInvites!: Invite[];
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'recurring-group-invite': RecurringGroupInvite;
  }
}
